import React, { useEffect, useState } from "react";
import "./personality.css";

// 🖼️ Posters
import blackswan from "../../movies/sonadora/blackswan.jpg";
import invictus from "../../movies/sonadora/invictus.jpg";
import littlemisssunshine from "../../movies/sonadora/littlemisssunshine.jpg";
import milliondollarbaby from "../../movies/sonadora/milliondollarbaby.jpg";
import moneyball from "../../movies/sonadora/moneyball.jpg";
import slumdogmillionaire from "../../movies/sonadora/slumdogmillionaire.jpg";
import thedanishgirl from "../../movies/sonadora/thedanishgirl.jpg";
import theshawshankredemption from "../../movies/sonadora/theshawshankredemption.jpg";
import thesocialnetwork from "../../movies/sonadora/thesocialnetwork.jpg";
import thetheoryofeverything from "../../movies/sonadora/thetheoryofeverything.jpg";

const movies = [
  {
    title: "Black Swan",
    image: blackswan,
    director: "Darren Aronofsky",
    year: 2010,
    cast: "Natalie Portman, Mila Kunis, Vincent Cassel",
    synopsis:
      "Una bailarina lucha por la perfección en su papel principal y se enfrenta a su lado oscuro."
  },
  {
    title: "Invictus",
    image: invictus,
    director: "Clint Eastwood",
    year: 2009,
    cast: "Morgan Freeman, Matt Damon",
    synopsis:
      "La historia de cómo Nelson Mandela usó el rugby para unir a Sudáfrica tras el apartheid."
  },
  {
    title: "Little Miss Sunshine",
    image: littlemisssunshine,
    director: "Jonathan Dayton, Valerie Faris",
    year: 2006,
    cast: "Steve Carell, Toni Collette, Abigail Breslin",
    synopsis:
      "Una familia disfuncional viaja a un concurso de belleza infantil, enfrentando sus conflictos."
  },
  {
    title: "Million Dollar Baby",
    image: milliondollarbaby,
    director: "Clint Eastwood",
    year: 2004,
    cast: "Hilary Swank, Clint Eastwood, Morgan Freeman",
    synopsis:
      "Una joven boxeadora lucha por alcanzar sus sueños mientras forma un vínculo con su entrenador."
  },
  {
    title: "Moneyball",
    image: moneyball,
    director: "Bennett Miller",
    year: 2011,
    cast: "Brad Pitt, Jonah Hill",
    synopsis:
      "El gerente general de un equipo de béisbol revoluciona el deporte usando estadísticas."
  },
  {
    title: "Slumdog Millionaire",
    image: slumdogmillionaire,
    director: "Danny Boyle",
    year: 2008,
    cast: "Dev Patel, Freida Pinto",
    synopsis:
      "Un joven de los barrios bajos de Mumbai participa en un concurso televisivo para cambiar su vida."
  },
  {
    title: "The Danish Girl",
    image: thedanishgirl,
    director: "Tom Hooper",
    year: 2015,
    cast: "Eddie Redmayne, Alicia Vikander",
    synopsis:
      "La historia real de Lili Elbe, una de las primeras personas en someterse a cirugía de reasignación de sexo."
  },
  {
    title: "The Shawshank Redemption",
    image: theshawshankredemption,
    director: "Frank Darabont",
    year: 1994,
    cast: "Tim Robbins, Morgan Freeman",
    synopsis:
      "Un hombre injustamente encarcelado forma una amistad duradera mientras busca la redención."
  },
  {
    title: "The Social Network",
    image: thesocialnetwork,
    director: "David Fincher",
    year: 2010,
    cast: "Jesse Eisenberg, Andrew Garfield",
    synopsis:
      "La historia de la creación de Facebook y los conflictos legales y personales de sus fundadores."
  },
  {
    title: "The Theory of Everything",
    image: thetheoryofeverything,
    director: "James Marsh",
    year: 2014,
    cast: "Eddie Redmayne, Felicity Jones",
    synopsis:
      "La vida y carrera del físico Stephen Hawking, y su relación con Jane Wilde."
  }
];

// ⭐⭐⭐⭐⭐ SVGs
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Sonadora() {
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMoviesSonadora") || "{}")
  );

  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatingsSonadora") || "{}")
  );

  useEffect(() => window.scrollTo(0, 0), []);

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMoviesSonadora", JSON.stringify(s));

    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatingsSonadora", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatingsSonadora", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Soñadora</h1>
      <p>
        No solo literalmente soñadora, ya cada noche es una nueva aventura dentro de su mente...
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">

                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>

              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Sonadora;

